import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Button, Col, Container, FormControl, Row} from "react-bootstrap";

import {service as ContextFileService} from "../../../Services/ContextFileService";
import {Glyphicon} from "../../Common/GlyphIcon";

import {useDebouncedEffect,} from "../../../Hooks/EffectHooks";
import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useEditContextNodeId,} from "../../../Hooks/PermissionHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";

import {useClassNames} from "../../../Hooks/StyleHooks";

import {useStreamBankFileDrop} from "../../../Hooks/useStreamBankFileDrop";
import {FileBrowserTable} from "../../Common/FileBrowser/Table";
import {selectDeepestBreadcrumb} from "../../../Redux/Selectors/contextSelectors";

export const FilesIndexPage = (props) => {
    useCheckAuth();

    const classNames = useClassNames('sb-programs-file-browser-page');
    const makePageRequest = useMakePageRequest();
    const editContextNodeId = useEditContextNodeId();

    const node = useSelector(selectDeepestBreadcrumb);
    const contextNodeId = useSelector(state => state.contextState.context.contextNodeId);
    
    const {
        fileUploadComponents,
        lastChanged,
        getRootProps,
        showFilePicker,
    } = useStreamBankFileDrop(contextNodeId);

    const [files, setFiles] = useState([]);
    const [textFilter, setTextFilter] = useState('');

    useEffect(() => {
        loadData();
    }, [contextNodeId, lastChanged]);

    useDebouncedEffect(() => {
        loadData();
    }, [textFilter]);

    const loadData = () => {
        if(contextNodeId === undefined) {
            // this means the page is still loading and we don't have a currentContextNodeId yet
            // (if we are on the root context currentContextNodeId will be null)
            // in order to prevent a race condition bug that might load the root context
            // files instead of the current context, we don't perform makePageRequest
            // in this situation
            return;
        }

        void makePageRequest(
            _ => ContextFileService.GetContextFiles(contextNodeId, textFilter),
            files => setFiles(files.result),
        );
        
        // TODO: make this work again?
        // tableComponent.current?.changeSort?.("created");
        // tableComponent.current?.changeSortToDesc?.();
    };

    const addToSearch = (text) => {
        if (textFilter === '') {
            setTextFilter(text);
        } else {
            setTextFilter(`${textFilter} ${text}`);
        }
    };

    const clearSearch = () => {
        if (textFilter !== '') {
            setTextFilter('');
        }
    };

    return <div {...getRootProps()}>
        {fileUploadComponents}
        <Container className={classNames}>
            <Row>
                <Col xs={12} md={12}>
                    <div className="float-right">
                        {
                            editContextNodeId(contextNodeId) ?
                                <Button variant="link" className="float-right h3" onClick={showFilePicker}>
                                    <Glyphicon glyph="plus-sign">Add File(s)</Glyphicon>
                                </Button>:
                                null
                        }
                    </div>
                    <h2 className="atomic-sectionheader">
                        {node?.title} Files
                    </h2>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <div className="float-right bottom10" style={{width: '215px'}}>
                        <FormControl
                            style={{width: '100%'}}
                            type="text"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoComplete="off"
                            spellCheck={false}
                            value={textFilter}
                            placeholder="Search name or tags"
                            onChange={(x) => setTextFilter(x.target.value)}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                     <FileBrowserTable
                        className="fixed"
                        Data={files}
                        ReloadData={loadData}
                        AddToSearch={addToSearch}
                        HasFilters={textFilter !== ''}
                        ClearFilters={clearSearch}
                    />
                </Col>
            </Row>
        </Container>
    </div>
}

